import React, { useCallback } from 'react';
import { BlankImage } from './blank-image';
const FooterSocialIcon = ({ src, link, spacing, wrap, alt, name, onShareClick, }) => {
    const aStyle = {
        verticalAlign: 'middle',
        display: 'inline-block',
        textDecoration: 'none',
    };
    const onClick = useCallback((e) => {
        if (onShareClick) {
            onShareClick(name, e);
        }
    }, [onShareClick, name]);
    const style = wrap ? { margin: '6px' } : {};
    const className = wrap ? 'social-icon social-icon-wrap' : 'social-icon';
    return (React.createElement("a", { style: aStyle, href: link, target: "_blank", onClick: onClick },
        React.createElement("img", { className: className, src: src, width: 28, height: 28, alt: alt, style: style }),
        !wrap && !!spacing && (React.createElement(BlankImage, { className: "social-icon-spacer", width: 6, alt: alt === undefined ? undefined : '' }))));
};
export default FooterSocialIcon;
//# sourceMappingURL=footer-social-icon.js.map